// extracted by mini-css-extract-plugin
module.exports = {"win-card-box":"gx","winCardBox":"gx","win-card-btn-detail":"gy","winCardBtnDetail":"gy","win-card-dec":"gz","winCardDec":"gz","win-card-name":"gA","winCardName":"gA"};